import { format } from 'date-fns';

export function getEffectiveRenewalStatus(sub) {
  if (!sub) return 'pending';
  return sub.renewalStatus || sub.status || 'pending';
}

export function formatStoreLabel(sub) {
  const store = sub?.store;
  const platform = sub?.platform;
  if (store === 'apple') return 'Apple App Store';
  if (store === 'google') return 'Google Play';
  if (store === 'web') return 'Web';
  if (store === 'mobile') return 'Mobile';
  if (platform) return `${platform} Store`;
  return 'Manual';
}

export function formatEntitlementLabel(sub) {
  if (!sub) return 'none';
  if (sub.entitlementType) return sub.entitlementType;
  if (sub.isPremium) return 'premium';
  if (sub.isTrialActive) return 'trial';
  return 'none';
}

export function formatBillingLabel(sub) {
  if (!sub) return '—';
  if (sub.billingPeriod === 'annual') {
    const cents = sub.annualPriceCents ?? 5999;
    return `$${(cents / 100).toFixed(2)}/year`;
  }
  if (sub.billingPeriod === 'monthly') return 'Monthly';
  if (sub.annualPriceCents) return `$${(sub.annualPriceCents / 100).toFixed(2)}/year`;
  return '$59.99/year';
}

export function formatAuditDate(value) {
  if (!value) return '—';
  try {
    return format(new Date(value), 'MMM d, yyyy');
  } catch {
    return '—';
  }
}

export function subscriptionAuditSidebarRows(sub) {
  if (!sub) return [];
  const devices = sub.registeredDeviceIds || sub.deviceIds || [];
  return [
    ['Entitlement', formatEntitlementLabel(sub)],
    ['Renewal', getEffectiveRenewalStatus(sub)],
    ['Trial', sub.trialStatus || (sub.isTrialActive ? 'active' : 'inactive')],
    ['Billing', formatBillingLabel(sub)],
    ['Store', formatStoreLabel(sub)],
    ['Renews', formatAuditDate(sub.expiresAt)],
    ['Last verified', formatAuditDate(sub.lastVerifiedAt)],
    ['Grace ends', formatAuditDate(sub.gracePeriodEndsAt)],
    ['Devices', devices.length ? `${devices.length} registered` : '—'],
  ];
}

export function hasClientContext(ctx) {
  if (!ctx) return false;
  return Boolean(
    ctx.appVersion
    || ctx.buildNumber
    || ctx.platform
    || ctx.osVersion
    || ctx.deviceModel
    || ctx.locale
    || ctx.networkState
    || ctx.currentScreen
    || ctx.pageUrl
    || ctx.viewport
    || ctx.reproSteps
    || ctx.crashFlag
    || (Array.isArray(ctx.browserConsole) && ctx.browserConsole.length)
  );
}

export function getRevenuePlatformUrl(sub) {
  const store = sub?.store || sub?.platform;
  if (store === 'apple' || store === 'ios') return 'https://appstoreconnect.apple.com/';
  if (store === 'google' || store === 'android') return 'https://play.google.com/console/';
  return null;
}

export function clientContextMetadataRows(ctx) {
  if (!ctx) return [];
  return [
    ['App version', ctx.appVersion],
    ['Build', ctx.buildNumber],
    ['Platform', ctx.platform],
    ['OS', ctx.osVersion],
    ['Device', ctx.deviceModel],
    ['Locale', ctx.locale],
    ['Network', ctx.networkState],
    ['Screen', ctx.currentScreen],
    ['Page URL', ctx.pageUrl],
    ['Viewport', ctx.viewport],
    ['Console events', Array.isArray(ctx.browserConsole) && ctx.browserConsole.length ? String(ctx.browserConsole.length) : null],
    ['Crash reported', ctx.crashFlag ? 'Yes' : 'No'],
  ];
}
